import { fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'

import StyledAlert from '@elements/StyledAlert'

const AlertContainer = styled.div`
  width: 100%;
  padding: 0 ${size(2)} ${size(1)} ${size(2)};
`

const alertStyles = {
  lineHeight: fontSize('lg'),
  fontSize: fontSize('xs'),
}

const NearbyFilterRightNowAlert = ({}) => {
  return (
    <AlertContainer>
      <StyledAlert kind='info' AlertStyles={alertStyles}>
        Profiles may specify different location and position in their (right now) looking status
      </StyledAlert>
    </AlertContainer>
  )
}

export { NearbyFilterRightNowAlert }
